import styled from "@emotion/styled";
import { StyledImage } from "../Image/Image";

export const PLPCardImage = styled(StyledImage)`
  width: 100%;
  aspect-ratio: 186/240;
  object-fit: cover;
  display: block;
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 186/240;
  overflow: hidden;
`;

export const WishlistIconWrapper = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TopOverlayRow = styled.div`
  position: absolute;
  top: 4px;
  left: 0;
  right: 0;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0;
`;

export const BottomOverlayRow = styled.div`
  position: absolute;
  bottom: 4px;
  left: 4px;
  z-index: 1;
`;
